var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Helper that generates the appropriate '&::after' object
 * given the matrix of isRequired and necessityIndicator
 */
export var getNecessityIndicatorStyling = function (isRequired, necessityIndicator) {
    var requiredIndicator = necessityIndicator === 'label' ? '" (required)"' : '"*"';
    var optionalIndicator = necessityIndicator === 'label' ? '" (optional)"' : '""';
    var afterContent = isRequired ? requiredIndicator : optionalIndicator;
    return {
        '&::after': {
            content: afterContent,
            color: 'currentcolor',
            display: 'inline',
        },
    };
};
/**
 * Generates the appropriate style object for the provided variant with some optional overrides
 */
var getVariantStyling = function (variant, color, fontWeight, fontSize) {
    switch (variant) {
        case 'uppercase':
            return {
                color: color || 'gray-70',
                fontWeight: fontWeight || 3,
                fontSize: fontSize || 0,
                letterSpacing: 'tracked',
                textTransform: 'uppercase',
                lineHeight: 'copy',
                paddingBottom: 1,
                fontStyle: 'normal',
                verticalAlign: 'middle',
            };
        case 'sentencecase':
            return {
                color: color || 'black',
                fontWeight: fontWeight || 4,
                fontSize: fontSize || 1,
                display: 'block',
                paddingBottom: 2,
            };
        default:
            return {
                color: color,
                fontWeight: fontWeight,
                fontSize: fontSize,
            };
    }
};
export var getLabelSx = function (variant, necessityIndicator, isRequired, fontWeight, fontSize, color) {
    return __assign(__assign({}, getNecessityIndicatorStyling(isRequired, necessityIndicator)), getVariantStyling(variant, color, fontWeight, fontSize));
};
